export default function Emissions({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2C10 3.10457 9.10457 4 8 4C7.97161 4 7.94337 3.99941 7.91527 3.99824C7.70985 4.58176 7.15377 5 6.5 5C6.5 5.55228 6.05228 6 5.5 6C4.94772 6 4.5 5.55228 4.5 5C4.5 4.58418 4.75379 4.22765 5.11492 4.07683C5.04088 3.89926 5 3.7044 5 3.5C5 2.84623 5.41825 2.29015 6.00176 2.08473C6.00059 2.05663 6 2.02839 6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2Z"
        fill="currentColor"
      />
      <path
        d="M13.9153 5.99824C13.7099 6.58175 13.1538 7 12.5 7C12.5 7.55228 12.0523 8 11.5 8C10.9477 8 10.5 7.55228 10.5 7C10.5 6.58418 10.7538 6.22765 11.1149 6.07683C11.0409 5.89926 11 5.7044 11 5.5C11 4.84623 11.4182 4.29015 12.0018 4.08473C12.0006 4.05663 12 4.02839 12 4C12 2.89543 12.8954 2 14 2C15.1046 2 16 2.89543 16 4C16 5.10457 15.1046 6 14 6C13.9716 6 13.9434 5.99941 13.9153 5.99824Z"
        fill="currentColor"
      />
      <path
        d="M4.33333 7L2 15H9H14L12.3333 9H10.6667L9 15L6.66667 7H4.33333Z"
        fill="currentColor"
      />
      <path
        d="M0 17C0 16.4477 0.447715 16 1 16H15C15.5523 16 16 16.4477 16 17V20H0V17Z"
        fill="currentColor"
      />
    </svg>
  )
}
